module.exports = __webpack_public_path__ + "img/icon-line.9ecc1580.png";